import { useState, useEffect } from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import { useArticles } from "../UseDataReader/useArticles";
import { ApiLink } from "../APILink/ApiLink";
import authHeader from "../Auth/authHeader";
import axios from "axios";

export default function ArticleAutocompleteEdit({
  reloadKey,
  articleId,
  onSelect,
  onClear,
  label = "Kërko Artikullin",
  labelId,
  priceType,
}) {
  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const headers = authHeader();

  const { listArticles, loadingInitial, loadingMore, setPage, hasMore } =
    useArticles(searchTerm);

  // =========================
  // PRELOAD ARTIKULLI (EDIT)
  // =========================
  useEffect(() => {
    if (!articleId) {
      setValue(null);
      setInputValue("");
      return;
    }

    let active = true;

    const loadById = async () => {
      try {
        const res = await axios.get(
          `${ApiLink.API_URL}Article/pick/${articleId}`,
          { headers },
        );

        if (!active) return;

        const article = res.data;
        setValue(article);
        setInputValue(`${article.Barcode} - ${article.ArticleName}`);
      } catch (err) {
        console.error("Failed to load article by id", err);
      }
    };

    loadById();

    return () => {
      active = false;
    };
  }, [articleId]);

  // =========================
  // SEARCH (debounce)
  // =========================
  useEffect(() => {
    const delay = setTimeout(() => {
      setSearchTerm(inputValue);
      setPage(1);
    }, 300);

    return () => clearTimeout(delay);
  }, [inputValue, setPage]);

  // =========================
  // Infinite scroll
  // =========================
  const handleScroll = (event) => {
    const listbox = event.currentTarget;
    if (
      listbox.scrollTop + listbox.clientHeight >= listbox.scrollHeight - 5 &&
      hasMore &&
      !loadingMore
    ) {
      setPage((prev) => prev + 1);
    }
  };

  // =========================
  // Selection
  // =========================
  // const handleChange = (_, option) => {
  //   if (!option) {
  //     setValue(null);
  //     setInputValue("");
  //     onClear?.();
  //     return;
  //   }

  //   setValue(option);
  //   setInputValue(`${option.Barcode} - ${option.ArticleName}`);
  //   onSelect?.(option);
  // };

  useEffect(() => {
    setSearchTerm("");
    setPage(1);
  }, [reloadKey]);

  return (
    <Autocomplete
      fullWidth
      options={listArticles}
      value={value}
      inputValue={inputValue}
      id={labelId}
      onChange={(_, option) => {
        if (!option) {
          setValue(null);
          setInputValue("");
          onClear?.();
          return;
        }
        setValue(option);
        setInputValue(`${option.Barcode} - ${option.ArticleName}`);
        onSelect?.(option);
      }}
      onInputChange={(e, v, reason) => {
        if (reason === "input") {
          setInputValue(v);
        }
      }}
      onOpen={() => {
        // Kur hapet dropdown, reset searchTerm vetëm nëse input nuk po shkruhet
        setSearchTerm("");
      }}
      isOptionEqualToValue={(o, v) => o.ArticleID === v?.ArticleID}
      getOptionLabel={(o) => (o ? `${o.Barcode} - ${o.ArticleName}` : "")}
      ListboxProps={{
        style: { maxHeight: 300, overflow: "auto" },
        onScroll: handleScroll,
      }}
      loading={loadingInitial}
      filterOptions={(x) => x}
      renderOption={(props, option, { index }) => (
        <li
          {...props}
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          {/* <div>
            <div>{option.Barcode}</div>
            <div style={{ fontSize: 12 }}>{option.ArticleName}</div>
          </div> */}
          <div>
            <div>{option.Barcode}</div>
            <div style={{ fontSize: 15, fontWeight: "bold" }}>
              {option.ArticleName}
            </div>
          </div>
          {priceType === "sales" ? (
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <strong>{(option.SalesPrice ?? 0).toFixed(2)}€</strong>
              {loadingMore && index === listArticles.length - 1 && (
                <CircularProgress size={14} />
              )}
            </div>
          ) : (
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <strong>{(option.PurchasePrice ?? 0).toFixed(2)}€</strong>
              {loadingMore && index === listArticles.length - 1 && (
                <CircularProgress size={14} />
              )}
            </div>
          )}
          {/* <div>
            <strong>{(option.SalesPrice ?? 0).toFixed(2)}€</strong>
            {loadingMore && index === listArticles.length - 1 && (
              <CircularProgress size={14} />
            )}
          </div> */}
        </li>
      )}
      renderInput={(params) => <TextField {...params} label={label} style={{width:"95%"}}/>}
    />
  );
}
